import React from "react";
import IntroImg from "./assets/TERENCE-no-bg.webp";

const Intro = () => {
  return (
    <div className="h-full bg-secondary-background-color">
      <div className="grid  grid-rows-2 lg:grid-rows-none  lg:grid-cols-4 h-full">
        <div className="row-span-1 lg:col-start-2 lg:col-span-1 h-full flex justify-center items-center">
          <div className="md:flex md:flex-col justify-center md:items-center ">
            <h1 className="text-2xl text-center py-4 hidden lg:block font-Montserrat">
              ABOUT ME
            </h1>
            <div className="lg:text-xl p-4 lg:p-0 text-center">
              Hello, I'm{" "}
              <span className="font-bold">
                <b>NKWETACHA TERENCE{"  "}</b>
              </span>
              a certified software engineer with over 4+ years of experience who
              not only possesses the technical ability to build top-tier
              software but also harbors a deep desire to make a difference in
              the world. With an unwavering commitment to continuous growth, a
              passion for innovation, and a natural affinity for leadership, I
              am dedicated to delivering impactful solutions that shape a
              brighter future for all.
              <br />
              <br />
              Have a better look at my CV.
            </div>
            <div className="flex mt-4 lg:mt-8 justify-center  w-full">
              <a
                href="https://wa.me/237695442479?text=Hello%2C%20I'm%20%5BYOUR%20%NAME%20%HERE%5D%20will%20like%20to%20have%20a%20better%20look%20at%20your%20CV"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="lg:w-48 lg:h-16 w-44 px-6 py-2 ">
                  View CV
                </button>
              </a>
            </div>
          </div>
        </div>
        <div className="row-span-1 lg:col-start-3 overflow-hidden lg:col-span-2 flex justify-center items-center">
          <img className="" src={IntroImg} alt="TERENCE" />
        </div>
      </div>
      {/* </div> */}
    </div>
  );
};

export default Intro;
